{
  "tabs": {
    "chat": "Զրույց",
    "reminders": "Հիշեցումներ",
    "calendar": "Օրացույց",
    "settings": "Կարգավորումներ"
  },
  "common": {
    "cancel": "Չեղարկել",
    "save": "Պահպանել",
    "confirm": "Հաստատել",
    "delete": "Ջնջել",
    "back": "Հետ",
    "close": "Փակել",
    "edit": "Խմբագրել",
    "search": "Որոնել",
    "all": "Բոլորը",
    "loading": "Բեռնվում է...",
    "error": "Ինչ-որ բան սխալ է",
    "notFound": "Չգտնվեց",
    "tryAgain": "Խնդրում ենք կրկին փորձել",
    "retry": "Կրկին փորձել",
    "undo": "Հետ կանչել",
    "pullToRefresh": "Քաշել թարմացնելու համար",
    "justNow": "հիմա"
  },
  "auth": {
    "welcome": "Բարի գալուստ FishMemory",
    "tagline": "Ձեր WhatsApp հիշեցումների օգնականը, հիմա ձեր գրպանում։",
    "subtitle": "Ձեր WhatsApp հիշեցումների օգնականը, հիմա ձեր գրպանում։",
    "phoneLabel": "Ձեր WhatsApp համարը",
    "phoneHint": "Մենք կուղարկենք վավերացման կոդ WhatsApp-ով",
    "invalidPhone": "Խնդրում ենք մուտքագրել վավեր հեռախոսահամար",
    "continue": "Շարունակել",
    "enterPhone": "Մուտքագրեք ձեր WhatsApp համարը",
    "phonePlaceholder": "Հեռախոսահամար",
    "sendCode": "Ուղարկել կոդը",
    "verifyTitle": "Վավերացնել ձեր համարը",
    "otpSentTo": "6-հատ թվային կոդ ուղարկվել է {{phone}} WhatsApp-ով",
    "enterFullCode": "Խնդրում ենք մուտքագրել բոլոր 6 թվերը",
    "invalidOtp": "Անվավեր կոդ։ Խնդրում ենք կրկին փորձել։",
    "otpFailed": "Կոդի ուղարկումը ձախողվեց։ Փորձեք կրկին։",
    "otpResent": "Կոդը նորից ուղարկվեց",
    "resendIn": "Վերակազմակերպել {{seconds}} վրկ հետո",
    "resendCode": "Վերակազմակերպել կոդը",
    "enterOtp": "Մուտքագրեք WhatsApp-ին ուղարկված կոդը",
    "verify": "Վավերացնել",
    "resend": "Վերակազմակերպել կոդը",
    "wrongNumber": "Սխալ համարը՞",
    "backToPhone": "Վերադառնալ հեռախոսին",
    "editPhone": "Խմբագրել հեռախոսահամարը",
    "error": "Սխալ",
    "setupTitle": "Գործը կարգավորենք",
    "setupSubtitle": "Դրանք միշտ կարող եք փոխել Կարգավորումներ բաժնում",
    "namePlaceholder": "Ձեր անունը",
    "letsGo": "Ավարտել կարգավորումը",
    "skipForNow": "Բաց թողնել հիմա"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Մուտքագրեք հաղորդագրություն...",
    "inputPlaceholder": "Մուտքագրեք հաղորդագրություն...",
    "typing": "FishMemory-ն գրում է...",
    "online": "Առցանց",
    "connecting": "Կապվում է...",
    "reconnecting": "Կրկին կապվում է...",
    "offline": "Անցանց",
    "empty": "Սկսեք զրույցը",
    "emptyHint": "Ստեղծեք հիշեցումներ, ստուգեք ձեր օրացույցը կամ խնդրեք օգնություն։",
    "emptyAction": "Ուղարկել օրինակ հիշեցում",
    "actions": "Զրույցի գործողություններ",
    "keep": "Պահպանել հաղորդագրությունները",
    "clearTitle": "Մաքրել զրույցը",
    "clearConfirm": "Ջնջե՞լ բոլոր հաղորդագրությունները այս սարքից։ Սա չի կարող հետ վերադարձվել։",
    "clear": "Մաքրել զրույցը",
    "optionSelected": "Ընտրված է՝ {{label}}",
    "sendingSelection": "Ուղարկվում է...",
    "connectionLost": "Կրկին կապվում է..."
  },
  "reminders": {
    "title": "Իմ հիշեցումները",
    "active": "Ակտիվ",
    "today": "Այսօր",
    "thisWeek": "Այս շաբաթ",
    "history": "Պատմություն",
    "items": "հատվածներ",
    "emptyTitle": "Հիշեցումներ դեռ չկան",
    "emptySubtitle": "Ստեղծեք մեկը զրույցից, և այն կհայտնվի այստեղ։",
    "emptyAction": "Բացել զրույցը",
    "filterActive": "Ակտիվ",
    "filterToday": "Այսօր",
    "filterWeek": "Այս շաբաթ",
    "filterHistory": "Պատմություն",
    "emptyState": "Հիշեցումներ դեռ չկան։ Սկսեք զրուցել։",
    "swipeDone": "Ավարտված",
    "swipeSnooze": "Հետաձգել",
    "swipeDelete": "Ջնջել",
    "search": "Որոնել հիշեցումները...",
    "upcoming": "Հաջորդը",
    "completed": "Ավարտված",
    "overdue": "Հետաձգված",
    "tomorrow": "Վաղը",
    "synced": "Համաժամեցված {{value}}",
    "swipeHint": "Հիշեցումը սահեցրեք՝ ավելին տեսնելու համար",
    "noResults": "Ոչ մի հիշեցում չի համապատասխանում ձեր որոնմանը",
    "noResultsHint": "Փորձեք այլ բան կամ մաքրել որոնումը",
    "deleteAllFailed": "Չհաջողվեց ջնջել բոլոր հիշեցումները"
  },
  "calendar": {
    "title": "Օրացույց",
    "today": "Այսօր",
    "tomorrow": "Վաղը",
    "completed": "ավարտված",
    "noEvents": "Ոչ մի ծրագրված բան չկա",
    "noEventsSubtitle": "Ընտրեք ամսաթիվ՝ հիշեցումներ և իրադարձություններ տեսնելու համար։",
    "googleEvent": "Google Օրացույց",
    "legendActive": "Ակտիվ",
    "legendRecurring": "Կրկնվող",
    "legendDone": "Ավարտված",
    "legendGoogle": "Google",
    "previousMonth": "Նախորդ ամիս",
    "nextMonth": "Հաջորդ ամիս",
    "previousYear": "Նախորդ տարի",
    "nextYear": "Հաջորդ տարի",
    "goToToday": "Գնալ այսօր",
    "all": "Բոլորը",
    "active": "Ակտիվ",
    "done": "Ավարտված",
    "paused": "Դադարեցված"
  },
  "settings": {
    "title": "Կարգավորումներ",
    "profile": "Պրոֆիլ",
    "name": "Ցուցադրման անուն",
    "enterName": "Մուտքագրեք ձեր անունը",
    "language": "Լեզու",
    "uiLanguage": "Գործառույթի լեզու",
    "uiLanguageHelp": "Փոխում է հավելվածի ինտերֆեյսը, օրացույցի պիտակները և դասավորությունը միայն այս սարքում։",
    "serverLanguage": "Զրույցի լեզու",
    "serverLanguageHelp": "Փոխում է սերվերի պատասխանների և հիշեցումների լեզուն ձեր հաշվի համար։",
    "timezone": "Ժամային գոտի",
    "currentTimezone": "Ընթացիկ ժամային գոտի",
    "timezoneHelp": "Բոլոր հիշեցումների ժամերը ցուցադրվում են այս ժամային գոտով։",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Պահպանել ժամային գոտին",
    "timezoneSaved": "Ժամային գոտի թարմացվեց",
    "detect": "Գտնել",
    "detectFailed": "Չհաջողվեց գտնել ժամային գոտին",
    "autoDetect": "Ավտոմատ հայտնաբերել GPS-ով",
    "notifications": "Ծանուցումներ",
    "notificationsHelp": "Հետհիշեցումները վերահսկում են կրկնվող ազդարարումները հիշեցման առաքումից հետո։ Սարքի ծանուցումների թույլտվությունները կառավարում եք հեռախոսի կարգավորումներում։",
    "pushEnabled": "Push ծանուցումներ",
    "autoDoneOnFire": "Ավտոմատ նշել ավարտված",
    "autoDoneOnFireDesc": "Երբ անջատված է, հիշեցումները մնում են ակտիվ մինչև նշեք դրանք ավարտված։",
    "googleCalendar": "Google Օրացույց",
    "google": "Google Օրացույց",
    "googleConnected": "Կապված է",
    "googleDisconnected": "Չի կապվել",
    "googleConnectedHelp": "Նոր հիշեցումները կարող են ավտոմատ համաժամեցվել օրացույցի հետ։",
    "googleDisconnectedHelp": "Կապեք Google Օրացույցը հիշեցումները և իրադարձությունները համաժամեցնելու համար։",
    "googleConnectFailed": "Չհաջողվեց կապել Google Օրացույցը",
    "connected": "Կապված է",
    "disconnected": "Չի կապվել",
    "connect": "Կապել",
    "disconnect": "Դուրս գալ",
    "autoSync": "Ավտոմատ համաժամեցում նոր հիշեցումների",
    "autosync": "Ավտոմատ համաժամեցում նոր հիշեցումների",
    "subscription": "Բաժանորդագրություն",
    "trialUsed": "Փորձնական: {{used}}/{{total}} օգտագործված",
    "trialStatus": "Փորձնական հասանելի է",
    "activeStatus": "Ակտիվ բաժանորդագրություն",
    "expiredStatus": "Բաժանորդագրությունը ավարտվել է",
    "unsubscribedStatus": "Չի բաժանորդագրվել",
    "about": "Մասին",
    "version": "Տարբերակ",
    "logout": "Դուրս գալ",
    "logoutTitle": "Դուրս գալ",
    "logoutConfirm": "Համոզվա՞ծ եք, որ ուզում եք դուրս գալ։",
    "noName": "Անունը չի սահմանվել",
    "serverConnection": "Սերվերի կապ",
    "serverUrl": "Սերվերի URL",
    "serverEdit": "Խմբագրել",
    "saveReconnect": "Պահպանել և կրկին կապվել",
    "resetDefault": "Վերականգնել սկզբնականը",
    "invalidServerUrlTitle": "Սխալ սերվերի URL",
    "invalidServerUrlMessage": "Մուտքագրեք վավեր http կամ https սերվերի URL, օրինակ https://example.com",
    "uiLanguageChangeFailed": "Չհաջողվեց փոխել հավելվածի լեզուն։ Խնդրում ենք կրկին փորձել։",
    "serverLanguageChangeFailed": "Չհաջողվեց փոխել զրույցի լեզուն։ Խնդրում ենք կրկին փորձել։",
    "timezoneChangeFailed": "Չհաջողվեց փոխել ժամային գոտին։ Խնդրում ենք կրկին փորձել։",
    "autoSyncChangeFailed": "Չհաջողվեց թարմացնել ավտոմատ համաժամեցումը։ Խնդրում ենք կրկին փորձել։",
    "nameChangeFailed": "Չհաջողվեց թարմացնել ցուցադրման անունը։ Խնդրում ենք կրկին փորձել։",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Հիշեցման մանրամասներ",
    "editTime": "Խմբագրել Ժամը",
    "rename": "Վերանվանել",
    "snooze": "Հետաձգել",
    "snooze15": "Հետաձգել 15 րոպե",
    "pause": "Դադարեցնել",
    "pauseReminder": "Դադարեցնել հիշեցումը",
    "resume": "Շարունակել",
    "resumeReminder": "Շարունակել հիշեցումը",
    "skip": "Անտեսել հաջորդը",
    "skipOccurrence": "Անտեսել այս դեպքը",
    "syncGoogle": "Համաժամեցնել Google-ի հետ",
    "delete": "Ջնջել",
    "deleteTitle": "Ջնջել հիշեցումը",
    "deleteConfirm": "Այս հիշեցումը կջնջվի ընդմիշտ։",
    "deleteRecurringTitle": "Ջնջել կրկնվող հիշեցումը",
    "deleteRecurringMessage": "Ցանկանու՞մ եք բաց թողնել այս դեպքը կամ ջնջել ամբողջ շարքը։",
    "deleteThisOccurrence": "Անտեսել այս դեպքը",
    "deleteEntireSeries": "Ջնջել ամբողջ շարքը",
    "done": "Ավարտված",
    "markDone": "Նշել որպես ավարտված",
    "undo": "Վերականգնել",
    "undoPrompt": "Պետք է կրկին ակտիվ լինի՞։ Վերականգնել հիմա։",
    "recurring": "Կրկնվող",
    "nextRun": "Հաջորդ գործարկում",
    "oneTime": "Միանգամյա",
    "pending": "Սպասում է",
    "sent": "Ուղարկված",
    "paused": "Դադարեցված",
    "active": "Ակտիվ",
    "snoozed": "Հետաձգված",
    "localTime": "Ցուցադրվում է ձեր տեղական ժամով",
    "recurrence": "Կրկնություն",
    "created": "Ստեղծվել է",
    "tags": "Թեգեր",
    "fireCount": "Կրկնությունների քանակը",
    "actions": "Գործողություններ",
    "none": "Ոչինչ",
    "snoozeFailed": "Չհաջողվեց հետաձգել հիշեցումը",
    "pauseFailed": "Չհաջողվեց դադարեցնել հիշեցումը",
    "resumeFailed": "Չհաջողվեց շարունակել հիշեցումը",
    "skipFailed": "Չհաջողվեց բաց թողնել հիշեցումը",
    "doneFailed": "Չհաջողվեց նշել հիշեցումը ավարտված",
    "undoFailed": "Չհաջողվեց վերականգնել հիշեցման կարգավիճակը",
    "deleteFailed": "Չհաջողվեց ջնջել հիշեցումը",
    "rescheduleTitle": "Կրկնաժամկետավորե՞լ",
    "rescheduleMsg": "Այս հիշեցումը ուշացել է։ Ցանկանու՞մ եք կրկնաժամկետավորել։",
    "reschedule15": "15 րոպեից",
    "reschedule60": "1 ժամից",
    "keepOverdue": "Պահել ինչպես կա"
  },
  "onboarding": {
    "slide1Title": "Բարի գալուստ FishMemory",
    "slide1Sub": "Ձեր անձնական հիշեցումների օգնականը՝ WhatsApp-ի միջոցով, ստեղծված ձեր գրպանի համար։",
    "slide2Title": "Պարզապես զրուցեք բնականաբար",
    "slide2Sub": "Մուտքագրեք հիշեցումները այնպես, ինչպես մտածում եք՝ «Հիշեցրիր վաղը ժամը 3-ին զանգահարել մորը» — մենք մնացածը կկատարենք։",
    "slide3Title": "Երբեք ոչինչ մի բաց թողեք",
    "slide3Sub": "Ստացեք ժամանակին ծանուցումներ, կազմակերպեք թեգերով և մնացեք ամեն ինչի գլխում։",
    "getStarted": "Սկսել",
    "next": "Հաջորդը",
    "firstReminderTitle": "Ստեղծեք ձեր առաջին հիշեցումը!",
    "firstReminderHint": "Փորձեք մուտքագրել ինչ-որ նման բան՝",
    "firstReminderExample": "Հիշեցրիր վաղը ժամը 9-ին ջուր խմել",
    "gotIt": "Հասկացա!",
    "notifRationaleTitle": "Մնացեք ժամանակին",
    "notifRationaleBody": "FishMemory-ն պետք է ծանուցումներ ուղարկի՝ ձեզ հիշեցնելու համար։ Դուք կստանաք ծանուցումներ միայն ձեր ստեղծած հիշեցումների համար։",
    "notifRationaleAllow": "Միացնել ծանուցումները",
    "notifRationaleLater": "Հնարավոր է հետո",
    "swipeHint": "Սահեցրեք աջ՝ արագ գործողությունների համար →",
    "calendarDragHint": "Քաշեք՝ ընդլայնելու համար ↕"
  }
}
